<template>
    <section class="comp_settings_price_mask">
        <div class="comp_scroller">
            <div class="comp_content">
                <header class="wrp_comp_header mod--row mod--row-flex mod--row-middle">
                    <div class="col">
                        <h1 class="part_ui_heading"><span>{{ $t('price_mask') }}</span></h1>
                    </div>
                </header>
                <div class="wrp_comp_body" v-on:scroll="handleGlobalScroll($event)">
                    <div class="mod--row mod--row-4">
                        <div class="col col--12" v-for="(item, index) in price_mask">
                            <div class="elm_nav_item  mod--row mod--row-flex">
                                <div class="col">
                                    <div class="part_ui_input"><input type="date" readonly :value="item.date"/></div>
                                </div>
                                <div class="col"><span>{{ dayFromDate(item.date) }}</span></div>
                                <div class="col mod--flex-grow mod--right">
                                    <div class="part_ui_input"><input type="number" min="0" step="0.01"
                                                                      :value="item.price"
                                                                      v-on:change="changePrice($event, index)"/></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import moment from 'moment';

export default {
    name: 'settings-price-mask',
    data() {
        return {
            price_mask: [],
        }
    },
    mounted() {
        this.price_mask = JSON.parse(localStorage.getItem('priceMask'));
    },
    methods: {
        dayFromDate(date) {
            return moment(date).format('dddd').toLowerCase();
        },
        changePrice(event, index) {
            this.price_mask[index].price = event.target.value;
            localStorage.setItem('priceMask', JSON.stringify(this.price_mask));
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/templates/comp/settings-price-mask.vue